"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN SendTask.
 *
 * A send task sends a user defined message to a ReceiveTask.
 *
 * In contrast to an Intermediate Message, a SendTask will block
 * the execution of the process, until a confirmation message from a
 * ReceiveTask was fetched.
 */
class SendTask extends ActivityBase_1.Activity {
    constructor() {
        super(...arguments);
        /**
         * The interval in which a SendTask should re-send its message.
         * Defaults to 500ms.
         */
        this.retryIntervalInMs = 500;
    }
    get bpmnType() {
        return Constants_1.BpmnType.sendTask;
    }
}
exports.SendTask = SendTask;
//# sourceMappingURL=SendTask.js.map